export const updateFormData = (formData) => ({
  type: "UPDATE_FORM_DATA",
  payload: formData,
});

export const submitFormData = () => ({
  type: "SUBMIT_FORM_DATA",
});

export const updateSchoolDetails = (formData) => {
  return {
    type: "SCHOOL_DETAILS",
    payload: formData,
  };
};

export const updateKeywordLabels = (keywordLabels) => {
  return {
    type: "UPDATE_KEYWORD_LABELS",
    payload: keywordLabels,
  };
};
